import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from '../Components/Org/HeroSection';
import KeyBenefitsSection from '../Components/Org/KeyBenefitsSection';
import HowItWorksSection from '../Components/common/HowItWorksSection';
import DataPrivacySection from '../Components/Org/DataPrivacySection';
import AchievementsSection from '../Components/common/AchievementsSection';
import IndustrySpotlightsSection from '../Components/Org/IndustrySpotlightsSection';
import CallToActionSection from '../Components/common/CallToActionSection';
import { orgSteps } from '../Components/Org/data/howItWorksData';
import { orgAchievements } from '../Components/Org/data/achievementsData';
import { industrySpotlights } from '../Components/Org/data/industrySpotlightsData';
import { OrgFAQs } from '../Components/Org/data/faqData';
import FAQSection from '../Components/common/FAQSection';
import NavBar from '../Components/NavBar';

const Organisation = () => {
  const ctaData = {
    heading: "Innovate Smarter with Lunor.Quest",
    description: "Unlock innovation tailored to your business needs. Collaborate with global AI talent to solve complex challenges while retaining full control over your data and solutions",
    buttonText: "Host Your Quest Now",
    buttonUrl: "https://app.lunor.quest/"
  };

  return (
    <>
      <Helmet>
        <title>Host AI Challenges with Lunor.Quest | Secure & Scalable Solutions</title>
        <meta 
          name="description" 
          content="Accelerate innovation with Lunor.Quest. Host AI challenges tailored to your business needs, collaborate with top global talent, and retain full ownership of your data and solutions. Launch your quest now!"
        />
      </Helmet>
      <div className="relative font-lexend">
        <NavBar />
        <HeroSection />
        <KeyBenefitsSection />
        <HowItWorksSection 
          steps={orgSteps}
          title="How it works"
        />
        <DataPrivacySection />
        <AchievementsSection 
          achievements={orgAchievements}
          title="What You Can Achieve"
        />
        <IndustrySpotlightsSection spotlights={industrySpotlights} />
        <CallToActionSection {...ctaData} />
        <FAQSection faqs={OrgFAQs} />
      </div>
    </>
  );
};

export default Organisation; 